import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomBrandSafetyCircular = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12m12.911-2.943h.582c.64 0 1.165.519 1.165 1.153v5.767c0 .634-.524 1.153-1.165 1.153H8.507c-.64 0-1.165-.519-1.165-1.153V10.21c0-.634.524-1.153 1.165-1.153h.582V7.903c0-1.591 1.304-2.883 2.911-2.883s2.911 1.292 2.911 2.883zm-4.075 4.036c0 .635.524 1.154 1.164 1.154s1.165-.52 1.165-1.154S12.641 11.94 12 11.94c-.64 0-1.165.52-1.165 1.153Zm-.583-5.19v1.154h3.494V7.903c0-.957-.78-1.73-1.747-1.73-.966 0-1.747.773-1.747 1.73"
  />,
  'CustomBrandSafetyCircular',
);

export default CustomBrandSafetyCircular;
